import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const Impressum = () => {
  const { isDark } = useTheme();
  
  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDark ? 'bg-[#0a0a0a] text-white' : 'bg-white text-gray-900'}`}>
      {/* Header */}
      <div className={`border-b ${isDark ? 'bg-[#0f0f0f] border-white/5' : 'bg-gray-50 border-gray-200'}`}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Link to="/" className={`inline-flex items-center gap-2 transition-colors mb-4 ${isDark ? 'text-[#7BA7C2] hover:text-white' : 'text-[#5A8BA6] hover:text-gray-900'}`}>
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          <h1 className="text-3xl font-bold">Impressum</h1>
          <p className={`mt-2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Gesetzliche Angaben gemäß § 5 TMG</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className={`prose max-w-none ${isDark ? 'prose-invert' : ''}`}>
          
          <section className="mb-10">
            <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Angaben zum Unternehmen</h2>
            <div className={`rounded-xl p-6 border ${isDark ? 'bg-white/5 border-white/10' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`mb-2 ${isDark ? 'text-gray-300' : 'text-gray-700'}`}><strong>Dion Hair Clinic GmbH</strong></p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Schürenweg 61</p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>41063 Mönchengladbach</p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>Deutschland</p>
              <p className={`mt-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                <strong>Telefon:</strong> <a href="tel:+4921612963017" className={isDark ? 'text-[#7BA7C2] hover:underline' : 'text-[#5A8BA6] hover:underline'}>+49 2161 2963017</a>
              </p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
                <strong>E-Mail:</strong> <a href="mailto:info@dionhairclinic.de" className={isDark ? 'text-[#7BA7C2] hover:underline' : 'text-[#5A8BA6] hover:underline'}>info@dionhairclinic.de</a>
              </p>
              <p className={`mt-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                <strong>Handelsregister:</strong> Amtsgericht Mönchengladbach, HRB 2183
              </p>
              <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
                <strong>Umsatzsteuer-ID:</strong> DE310907744
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Geschäftsführung</h2>
            <p className={isDark ? 'text-gray-300' : 'text-gray-700'}>Dilek Ergüney</p>
            <p className={isDark ? 'text-gray-300' : 'text-gray-700'}>Manuel Bayer</p>
            <p className={`text-sm mt-2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</p>
          </section>

          <section className="mb-10">
            <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Streitschlichtung</h2>
            <p className={`mb-4 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className={isDark ? 'text-[#7BA7C2] hover:underline' : 'text-[#5A8BA6] hover:underline'}>
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>Datenschutz</h2>
            <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
              Weitere Informationen entnehmen Sie bitte unserer{' '}
              <Link to="/datenschutz" className={isDark ? 'text-[#7BA7C2] hover:underline' : 'text-[#5A8BA6] hover:underline'}>Datenschutzerklärung</Link>.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Impressum;
